import { FULL_COUNTRY_OPTIONS_LIST } from '../constants';

export const getCountryLabel = (value: string): string => {
  const countryOption = FULL_COUNTRY_OPTIONS_LIST.find(option => option.value === value);
  return countryOption ? countryOption.label : value;
};
